import { CSSVar } from '../../../helpers/CSSVar';

export const SB_TOP_RADIUS = new CSSVar('sb-top-radius');
export const SB_BOTTOM_RADIUS = new CSSVar('sb-bottom-radius');
export const SB_HIGHLIGHT = new CSSVar('sb-highlight');
export const SB_BACKGROUND = new CSSVar('sb-background');
